import styled from "@emotion/styled";


export const PaymentDetailsWrapper = styled.div<{ theme: Theme, showBottomMargin?: boolean }>`
  .price-details {
    margin-bottom: 8px;
  };

  .content-layout {
    margin: 0px;
    border-radius: ${({ theme }) => theme.borders.radiusPrimary};
    overflow: hidden;
  };

  .accordion-title-bundle-text-layout {
    margin-top: 0px;
    display: ${({ theme }) => theme.paymentMethodCardBottomTextDisplay};
  }
  
  margin: 0px 20px;
  padding: 0px 0px;
`;

export const Wrapper = styled.div`
margin-left: 6px;
margin-bottom: 10px;
`;
